import { graphql, Link, navigate, useStaticQuery } from 'gatsby';
import React from 'react';
import LitImage from '../images/LitImage';
const TownCard = ({ town }) => {
  const image =
    town.townSlug?.mobileHeroImage ?? imageQuery().defaultImage.childImageSharp;

  const cardBody = (
    <>
      <div className="col-12 townCardHeader">
        <h4>{town.areaName}</h4>
        <h5>
          {town.available
            ? '1Gb service available'
            : town.inBuild
              ? 'In build'
              : 'Coming soon'}
        </h5>
      </div>
      <LitImage image={image} className="col-12 townCardBody" />
    </>
  );

  return (
    <div className="col-xl-4 col-md-6 col-sm-12 pb-4" id={town.id}>
      <div className="container">
        {town.townSlug?.slug ? (
          <Link className="row townCard" to={`/location/${town.townSlug.slug}`}>
            {cardBody}
          </Link>
        ) : (
          <div className="row townCard">{cardBody}</div>
        )}
      </div>
    </div>
  );
};

export default TownCard;

const imageQuery = () =>
  useStaticQuery(graphql`
    {
      defaultImage: file(
        relativePath: { eq: "hero-images/registerInterestHeaderMobile.jpg" }
      ) {
        childImageSharp {
          gatsbyImageData(
            quality: 75
            placeholder: BLURRED
            layout: CONSTRAINED
            formats: [AUTO, WEBP, AVIF]
          )
        }
      }
    }
  `);
